import { useCallback, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { SecondModalMode } from './InformationTitle';
import { dashboardActions } from '../../../../../../store/slices/dashboardSlice/dashboardSlice';

export const useInformationTitle = () => {
    const dispatch = useDispatch();
    // @ts-ignore
    const { information, is_customer, can_show_financial_info, is_can_archive_project } =
        useSelector(
            // @ts-ignore
            (store) => store.dashboardReducer
        );
    const [openSecondModal, setOpenSecondModal] = useState(false);
    const [secondModalMode, setSecondModalMode] = useState<{
        text: string;
        buttonText: string;
        onClick: () => Promise<void> | undefined;
    }>({ text: '', buttonText: '', onClick: undefined });

    const onEditInformation = useCallback(() => {
        dispatch(dashboardActions.onModalMode('editInformation'));
    }, []);

    const onClickIcon = useCallback(
        (mode: SecondModalMode) => {
            setOpenSecondModal(true);
            setSecondModalMode(textMapping[mode]);
        },
        [openSecondModal]
    );

    const onCansel = useCallback(() => {
        setOpenSecondModal(false);
    }, []);

    const onArchiveProject = useCallback(async () => {
        const archiveUrl = routable.getRoute('archiveProject');
        fetch(archiveUrl, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        }).then((response: Response) => {
            if (response.ok) {
                window.location.reload();
            }
        });
    }, []);

    const onDeleteProject = useCallback(async () => {
        window.location.href = routable.getRoute('deleteProject');
    }, []);

    const onRestoreProject = useCallback(async () => {
        window.location.href = routable.getRoute('restoreProject');
    }, []);

    const textMapping = {
        archiveProject: {
            text: i18next.t('useInformationTitle.return.popup.archiveProject'),
            buttonText: i18next.t('useInformationTitle.return.popup.archiveProjectButton'),
            onClick: onArchiveProject,
        },
        unArchiveProject: {
            text: i18next.t('useInformationTitle.return.popup.unArchiveProject'),
            buttonText: i18next.t('useInformationTitle.return.popup.unArchiveProjectButton'),
            onClick: onRestoreProject,
        },
        deleteProject: {
            text: i18next.t('useInformationTitle.return.popup.deleteProject'),
            buttonText: i18next.t('useInformationTitle.return.popup.deleteProjectButton'),
            onClick: onDeleteProject,
        },
    };

    return {
        onEditInformation,
        is_archive: information.is_archive,
        openSecondModal,
        secondModalMode,
        onClickIcon,
        onCansel,
        onArchiveProject,
        onDeleteProject,
        onRestoreProject,
        is_customer,
        can_show_financial_info,
        is_can_archive_project,
    };
};
